module.exports = __webpack_public_path__ + "static/img/img_file_3d.3f12b56.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mall/img_file_3d.png
// module id = r1q/
// module chunks = 1